import { lazy, Suspense } from 'react'
import type { Components } from 'react-markdown'

// react-markdown (+ l'écosystème remark/unified qu'il embarque) n'est chargé
// que sur les pages qui en ont besoin (résumé de prédication), jamais dans le
// bundle principal — important pour l'objectif 3G du reste du site.
const ReactMarkdown = lazy(() => import('react-markdown'))

const components: Components = {
  h1: ({ children }) => <h2 className="text-lg font-bold text-cmp-navy mt-6 mb-2 first:mt-0">{children}</h2>,
  h2: ({ children }) => <h2 className="text-lg font-bold text-cmp-navy mt-6 mb-2 first:mt-0">{children}</h2>,
  h3: ({ children }) => <h3 className="text-base font-bold text-cmp-navy mt-5 mb-2 first:mt-0">{children}</h3>,
  p: ({ children }) => <p className="text-gray-600 leading-relaxed mb-4 last:mb-0">{children}</p>,
  strong: ({ children }) => <strong className="font-semibold text-cmp-navy">{children}</strong>,
  ol: ({ children }) => <ol className="list-decimal list-outside pl-5 space-y-3 mb-4 marker:font-bold marker:text-cmp-gold">{children}</ol>,
  ul: ({ children }) => <ul className="list-disc list-outside pl-5 space-y-1.5 mb-4 marker:text-cmp-gold">{children}</ul>,
  li: ({ children }) => <li className="text-gray-600 leading-relaxed">{children}</li>,
  blockquote: ({ children }) => (
    <blockquote className="border-l-2 border-cmp-gold-light pl-4 italic text-cmp-ink my-4">{children}</blockquote>
  ),
  a: ({ children, href }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-cmp-blue font-medium hover:underline">
      {children}
    </a>
  ),
}

export default function RichText({ children }: { children: string }) {
  return (
    <Suspense fallback={<p className="text-gray-600 leading-relaxed whitespace-pre-line">{children}</p>}>
      <ReactMarkdown components={components}>{children}</ReactMarkdown>
    </Suspense>
  )
}
